import { render, staticRenderFns } from "./FormCrudCategory.vue?vue&type=template&id=716922cb"
import script from "./FormCrudCategory.vue?vue&type=script&lang=js"
export * from "./FormCrudCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports